import { Button, Takeover, useTranslation } from '@helios/frontend-core';

import { PalmettoIcon, PalmettoToaster } from '@palmetto/dsm-components';
import beachScene from '../../../../assets/beach-scene.gif';

import { CouponDetails } from '../usePriceAndCouponDetails';

const localePrefix = 'productDetail.productOverview.rewardsTakeover';

interface RewardsTakeoverProps {
  isOpen: boolean;
  onDismiss: () => void;
  couponDetails: CouponDetails;
  couponCode: string;
  trackingId: string;
}

const RewardsTakeover = ({ isOpen, onDismiss, couponDetails, couponCode, trackingId }: RewardsTakeoverProps) => {
  const { t } = useTranslation();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(couponCode);
    PalmettoToaster.success({ title: t(`${localePrefix}.couponCopied`) });
  };

  return (
    <Takeover isOpen={isOpen} onClose={onDismiss} trackingId={`${trackingId}-rewards-takeover`}>
      <div className="flex justify-center items-center w-full h-full py-24">
        <div className="h-full max-w-[672px] max-h-[1000px] flex flex-col justify-between">
          <div className="flex flex-col gap-20">
            <h2 className="heading-600 min-[376px]:heading-800 text-text-primary px-24">
              {couponDetails.rewardsHeader || t(`${localePrefix}.heading`)}
            </h2>
            <img src={beachScene} alt="" aria-hidden="true" className="w-full max-w-[500px] self-center scale-105" />
            <div className="flex flex-col gap-8 px-24">
              <button
                onClick={copyToClipboard}
                className="flex p-16 items-center gap-10 self-stretch rounded-16 border-2 border-input-border-default bg-input-bg-read-only w-full cursor-pointer"
              >
                <div className="w-full flex justify-between items-center text-input-content-tertiary ui-400">
                  <div className="flex items-center gap-10">
                    <PalmettoIcon name="coconutWithStraw" size="sm" />
                    <span>{couponCode}</span>
                  </div>
                  <div className="flex items-center gap-10">
                    {t(`${localePrefix}.copy`)}
                    <PalmettoIcon name="copy" size="sm" />
                  </div>
                </div>
              </button>
              <p className="text-input-content-tertiary body-200 px-6">{t(`${localePrefix}.instructions`)}</p>
            </div>
          </div>
          <div className="flex gap-12 w-full flex-col md:flex-row-reverse px-24">
            <Button
              as="a"
              href={couponDetails.partnerUrl}
              target="_blank"
              rel="noopener noreferrer"
              emphasis="primary"
              layout="fill"
              trackingId={`${trackingId}-shop-partner`}
              className="truncate"
            >
              {couponDetails.ctaLabel || t('productDetail.productOverview.shopAtPartner')}
            </Button>
            <Button
              emphasis="secondary"
              layout="fill"
              onClick={onDismiss}
              trackingId={`${trackingId}-close`}
              className="truncate"
            >
              {t(`${localePrefix}.dismiss`)}
            </Button>
          </div>
        </div>
      </div>
    </Takeover>
  );
};

export default RewardsTakeover;
